import React from "react";

interface ValidateSSMLLintButtonProps {
    validateText: () => void;
}

const ValidateButton = ({validateText}: ValidateSSMLLintButtonProps) => {
    return (
        <button
            className="bg-accent hover:bg-accent-hover text-white font-medium px-5 py-2 rounded-lg transition-colors text-sm"
            onClick={validateText}
        >
            Validate
        </button>
    );
}

export default ValidateButton
